import { TableCell } from '@mui/material';
import { useDrag } from 'react-dnd';
import { ItemTypes } from './Map';

const Color = ({ primer, color }) => {
  const [{ isDragging }, drag] = useDrag(
    () => ({
      type: ItemTypes.PRIMER,
      item: { primer: primer },
      collect: (monitor) => ({
        isDragging: !!monitor.isDragging(),
      }),
    }),
    [primer]
  );

  return (
    <TableCell
      style={{
        height: '30px',
        width: '30px',
        backgroundColor: color,
        opacity: isDragging ? 0.5 : 1,
      }}
      ref={drag}
    />
  );
};

export default Color;
